import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FileDownloadHelper } from '@morningstar/shared/util';

@Injectable({
  providedIn: 'root'
})
export class DataExport {
  exportAsCSV(data: any[], headers: string[], displayHeaders: string[], filename: string): void {
    if (!data || data.length === 0) return;

    let csvContent = displayHeaders.join(',') + '\n';

    data.forEach(item => {
      const row = headers.map(header => {
        const value = this.getNestedValue(item, header);
        return typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value;
      });
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    this.downloadFile(blob, `${filename}.csv`);
  }

  exportAsPDF(data: any[], headers: string[], displayHeaders: string[], filename: string, title?: string): void {
    if (!data || data.length === 0) return;

    try {
      const doc = new jsPDF.default('landscape');
      const margin = 10;
      let yPos = margin;

      if (title) {
        doc.setFontSize(16);
        doc.text(title, margin, yPos);
        yPos += 15;
      }

      const now = new Date();
      doc.setFontSize(10);
      doc.text(`Generated: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`, margin, yPos);
      yPos += 10;

      const tableData = [];
      tableData.push(displayHeaders);

      data.forEach(item => {
        const row = headers.map(header => {
          const value = this.getNestedValue(item, header).toString();
          return value.length > 30 ? value.substring(0, 27) + '...' : value;
        });
        tableData.push(row);
      });

      doc.setFontSize(10);
      doc.setTextColor(0);

      const finalY = (doc as any).autoTable({
        startY: yPos,
        head: [displayHeaders],
        body: tableData.slice(1),
        margin: { top: margin, right: margin, bottom: margin, left: margin },
        styles: {
          overflow: 'linebreak',
          cellWidth: 'auto',
          cellPadding: 2
        },
        columnStyles: {},
        headStyles: { fillColor: [66, 66, 66] },
      });

      const pdfBlob = doc.output('blob');
      FileDownloadHelper.downloadFile(pdfBlob, 'application/pdf', `${filename}.pdf`);

    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  }

  private getNestedValue(obj: any, path: string): any {
    if (!obj || !path) return '';

    if (path.includes('.')) {
      const parts = path.split('.');
      let current = obj;

      for (const part of parts) {
        if (current === null || current === undefined) {
          return '';
        }
        current = current[part];
      }

      if (typeof current === 'boolean') {
        return current ? 'Yes' : 'No';
      }

      return current !== undefined && current !== null ? current : '';
    }

    if (typeof obj[path] === 'boolean') {
      return obj[path] ? 'Yes' : 'No';
    }

    return obj[path] !== undefined && obj[path] !== null ? obj[path] : '';
  }

  private downloadFile(blob: Blob, filename: string): void {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}